import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLoginByToken, useGetPlayerSessionInfo } from 'server';
import { userSetAttributesAction } from 'js/hooks/user/store/actions';

import { useLoginRequest } from './useLoginRequest';

export const useLoginBySessionToken = () => {
    const dispatch = useDispatch();
    const request = useLoginRequest();
    const loginByToken = useLoginByToken();
    const getPlayerSessionInfo = useGetPlayerSessionInfo();

    return useCallback(async (userName, pasSessionToken, { signal } = {}) => {
        const loginData = await loginByToken({ ...request, userName, sessionToken: pasSessionToken }, { signal });
        const playerSessionInfo = await getPlayerSessionInfo({ signal });

        const playerSessionInfoParams = playerSessionInfo?.parameters || [];
        const rootSessionStartTime = playerSessionInfoParams?.find(param => param.key === 'rootSessionStartTime')?.value || '';
        const { sessionToken, previousLoginTime, sessionTokenExpirationTime } = loginData || {};
        const sessionStartTime = Number(new Date(`${rootSessionStartTime.trim().replace(' ', 'T')}Z`)) || Date.now();

        dispatch(userSetAttributesAction({
            sessionToken,
            pasSessionToken,
            sessionStartTime,
            previousLoginTime,
            sessionTokenExpirationTime
        }));
    }, [
        dispatch,
        getPlayerSessionInfo,
        loginByToken,
        request
    ]);
};
